const CSRF_ERROR_PATTERNS = [/unable to verify your data submission/i, /\bcsrf\b/i];

const refreshTokens = (formEl, form) => {
  if (!form?.config?.Formie) {
    return Promise.resolve();
  }

  console.log("[Formie CSRF] refreshing tokens", {
    formId: form.config?.id,
    hasElement: !!formEl,
  });

  // Prime the CSRF cookie + hidden input via Formie's refresh endpoint.
  return form.config.Formie.refreshFormTokens(form)
    .then((result) => {
      console.log("[Formie CSRF] token refresh success", { formId: form.config?.id });
      return result;
    })
    .catch((err) => {
      console.warn("Formie CSRF refresh failed", err);
      throw err;
    });
};

document.addEventListener("onFormieReady", (event) => {
  const form = event.detail?.form;
  const formEl = event.target;

  console.log("[Formie CSRF] onFormieReady fired", {
    hasForm: !!form,
    hasElement: !!formEl,
    hasFormie: !!form?.config?.Formie,
  });

  if (!form || !formEl || !form.config?.Formie) {
    return;
  }

  // Run an early refresh so Safari users who lost cookies get a fresh token.
  refreshTokens(formEl, form);

  const handleSubmitError = (e) => {
    const message = e.detail?.errorMessage || e.detail?.message || "";

    console.log("[Formie CSRF] submit error received", { message });

    if (!CSRF_ERROR_PATTERNS.some((pattern) => pattern.test(message))) {
      console.log("[Formie CSRF] submit error not CSRF-related, skipping", { message });
      return;
    }

    // Only retry once per form render to avoid loops.
    if (formEl.dataset.fuiCsrfRetried) {
      console.log("[Formie CSRF] retry already attempted, skipping");
      return;
    }

    formEl.dataset.fuiCsrfRetried = "true";

    console.log("[Formie CSRF] retrying submit after refreshing tokens");

    refreshTokens(formEl, form)
      .then(() => form.initSubmit())
      .catch(() => {
        console.warn("[Formie CSRF] retry after refresh failed, clearing retry flag");
        delete formEl.dataset.fuiCsrfRetried;
      });
  };

  formEl.addEventListener("onFormieSubmitError", handleSubmitError);
  formEl.addEventListener("onFormieDestroy", () => {
    formEl.removeEventListener("onFormieSubmitError", handleSubmitError);
  });
});
